import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Box, Grid, Card, Container, Typography } from "@mui/material";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import InstockInInfeed from "../pages/InstockInInfeed";
import ProcessingInInfeed from "../pages/ProcessingInInfeed";
import CompletedInInfeed from "../pages/CompletedInInfeed";
import RejectInInfeed from "../pages/RejectInInfeed";
import StatusLineInInfeed from "../pages/StatusLineinInfeed";




function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function InfeedTab() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const StyledTab = styled(Tab)({
        "&.Mui-selected": {
            color: "red"
        }
    });


    return (

        <div className="App">
            <Helmet>
                <title>Infeed | MES</title>
            </Helmet>
                <Grid
                    container
                    style={{ paddingTop: 0, backgroundColor: '#e0f2f1' }}
                >
                    <Grid item lg={12} md={12} sm={12} xl={12} xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Box sx={{ width: '100%' }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs /*sx={{
                                    "& .MuiTab-root.Mui-selected": { color: "#88dbb0" },
                                    "& .MuiTabs-indicator": { bgcolor: "#88dbb0" }
                                }}*/ value={value} onChange={handleChange} aria-label="basic tabs example" variant="scrollable" scrollButtons="auto" sx={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto' }} >
                                    <Tab  label="In Stock" {...a11yProps(0)} />
                                    <Tab  label="Processing" {...a11yProps(1)} />
                                    <Tab  label="Completed" {...a11yProps(2)} />
                                    <Tab /*style={{color: '#ffffff'}}*/ label="Reject" {...a11yProps(3)} />
                                    <Tab  label="Status Line" {...a11yProps(4)} />
                                </Tabs>
                            </Box>
                            <CustomTabPanel value={value} index={0}>
                                <InstockInInfeed />
                            </CustomTabPanel>

                            <CustomTabPanel value={value} index={1}>
                                <ProcessingInInfeed />
                            </CustomTabPanel>

                            <CustomTabPanel value={value} index={2}>
                                <CompletedInInfeed />
                            </CustomTabPanel>

                            <CustomTabPanel value={value} index={3}>
                                <RejectInInfeed />
                            </CustomTabPanel>

                            <CustomTabPanel value={value} index={4}>
                                <StatusLineInInfeed />
                            </CustomTabPanel>
                        </Box>
                    </Grid>
                </Grid>
        </div>
    );
}





